import { ReactElement, MouseEvent } from "react";
import styled from "styled-components";
import { h } from "../../h";
import { ItemContainerStyled } from "./ItemContainerStyled";
import { ItemHidableStyled } from "./ItemHidableStyled";
import { formatTime } from "../../utils/date";
import { DURATION_STEP } from "../../config";

type LockLineProps = {
    time: number;
    index: number;
    onLockChange: (index: number, newLock: number) => void;
};

const LockLineContainerStyled = styled.div`
    padding-top: 20px;
    display: flex;
`;

const LockLineSideStyled = styled.div`
    flex: 1 1 0;
    border-bottom: 1px solid ${({ theme }) => theme.colorMain};
    margin-bottom: 10px;
`;

const LockLineMiddleStyled = styled.div`
    display: flex;
    flex: 0 0 500px;
`;

const LockLineControlsStyled = styled.div`
    display: flex;
`;

const LockLineIconStyled = styled(ItemHidableStyled)`
    cursor: pointer;
    width: 30px;
    text-align: center;
    user-select: none;

    ${ItemContainerStyled} &:hover {
        opacity: 1;
        font-weight: bold;
    }
`;

const LockLineTimeStyled = styled.div`
    width: 45px;
    text-align: center;
`;

export const LockLine = ({
    time,
    index,
    onLockChange,
}: LockLineProps): ReactElement => {
    return h(
        LockLineContainerStyled,
        {},
        h(LockLineSideStyled, {}),
        h(
            LockLineMiddleStyled,
            {},
            h(
                LockLineControlsStyled,
                {},
                h(
                    LockLineIconStyled,
                    {
                        onClick: (event: MouseEvent) =>
                            onLockChange(
                                index,
                                time - DURATION_STEP * (event.shiftKey ? 6 : 1),
                            ),
                    },
                    `-`,
                ),
                h(LockLineTimeStyled, {}, formatTime(time)),
                h(
                    LockLineIconStyled,
                    {
                        onClick: (event: MouseEvent) =>
                            onLockChange(
                                index,
                                time + DURATION_STEP * (event.shiftKey ? 6 : 1),
                            ),
                    },
                    `+`,
                ),
            ),
            h(LockLineSideStyled, {}),
        ),
        h(LockLineSideStyled, {}),
    );
};
